import { ButtonComponentConfig } from '../button';

export interface CardOneButtonOutput {
    button: ButtonComponentConfig;
    data: any;
}
